module.exports = __webpack_public_path__ + "static/media/debug.c04f0fb5.vert";